import { Box, Typography } from '@material-ui/core';
import React from 'react';

const ChatsNotFound = () => {
  return (
    <Box
      style={{
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img
        style={{ height: 60, width: 60, alignSelf: 'center' }}
        src={require('assets/images/icons/chat.png').default}
      />
      <Typography
        style={{ textAlign: 'center', fontSize: '1.4em', marginTop: '1rem' }}
      >
        {'Chat not selected'}
      </Typography>
    </Box>
  );
};

export default React.memo(ChatsNotFound);
